export const siteRoutes_DA = {
  // Toasts used for challenges
  routes: {
    headlines: {
      main: "Hoved",
      engagement: "Challenges",
      updates: "Opdateringer",
      profile: "Profil",
      tracker: "Game Tracker",
      studio: "Studio",
    },
    route: {
      home: "Hjem",
      zones: "Zoner",
      feed: "Feed",
      overview: "Oversigt",
      challenges: "Challenges",
      teams: "Hold",
      dailyTasks: "Daglige opgaver",
      news: "Nyheder",
      schedule: "Skema",
      winners: "Vindere",
      settings: "Indstillinger",
      leaderboard: "Leaderboard",
      gamepass: "Game Pass",
      feedback: "Feedback",
      gametracker: "Hent Game Tracker",
      create: {
        challenge: "Opret en challenge",
        news: "Opret en nyhed",
      },
      events: "Events",
    },
  },
};
